import YoutubeEmbed from '../YoutubeEmbed'
import SectionHeading from './SectionHeading'
import HomePageSlider from './HomePageSlider'
import { ContainerWrapper } from '../Container'
import SectionSubText from './SectionSubText'
import SectionHeadingWrapper from './SectionHeadingWrapper'
import Testimonials from '../Testimonials'

export const Reviews = ({ reviews }) => {
    return (
        <HomePageSlider>
            {reviews &&
                reviews.map((review, index) => {
                    return (
                        <div key={index} className="px-2">
                            <div className="olm-gradient p-[1px] rounded-xl">
                                <div className="bg-white rounded-xl">
                                    <div className="flex flex-col overflow-hidden">
                                        {/* <div className="relative h-64 flex justify-center"> */}
                                        <div className="rounded-xl">
                                            {/* <PlayWhiteIcon className="w-24 h-24 inset-0 absolute z-10 m-auto" /> */}
                                            {/* <img
                                                className="m-auto rounded-xl rounded-b-0"
                                                src={review.profile_photo_url}
                                                alt={review.author_name}
                                            /> */}
                                            {/* <iframe width="560" height="315" src={review.video} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
                                            <YoutubeEmbed
                                                cssClass={
                                                    'rounded-xl max-w-full'
                                                }
                                                url={review.video}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="olm-gradient rounded-t-none rounded-xl text-left p-10 space-y-3 text-white">
                                        <h3 className="font-semibold text-xl text-white">
                                            {review.author_name}
                                        </h3>
                                        <p className="overflow-hidden truncate-lines">
                                            {review.text}
                                        </p>
                                        <TextLink scheme="light">
                                            Read More
                                        </TextLink>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    )
                })}
        </HomePageSlider>
    )
}

function CustomersLoveUs({
    reviews,
    hasSectionHeading = false,
    sectionHeading,
    showTestimonials = false,
    allReviews = [],
}) {
    return (
        <ContainerWrapper>
            <div
                data-id="marketing-challenges"
                className="m-auto max-w-full xl:px-0 px-6 text-center">
                <SectionHeadingWrapper>
                    {hasSectionHeading ? (
                        sectionHeading
                    ) : (
                        <>
                            <SectionHeading>
                                <div className="space-x-2">
                                    <span>Our</span>
                                    <span className="olm-gradient-text leading-snug">
                                        Results
                                    </span>
                                    <span>Speak for Themselves</span>
                                </div>
                            </SectionHeading>
                            <SectionSubText>
                                Hear from our clients:
                            </SectionSubText>
                        </>
                    )}
                </SectionHeadingWrapper>

                <Reviews reviews={reviews} />
                {showTestimonials && <Testimonials reviews={allReviews} />}

                {/* <div className="text-center space-y-4">
                <Link href="/reviews">
                    <a className="inline-block text-sm text-gray-500 group hover:text-olm-black focus:outline-none focus:underline transition ease-in-out duration-150">
                        <button className="m-auto text-xl shadow-lg p-[2px]  rounded olm-gradient text-white font-semibold text-center bg-olm hover:bg-olh">
                            <span className="flex bg-white py-6 md:px-28 px-10 rounded text-olm">
                                See More Testimonials
                            </span>
                        </button>
                    </a>
                </Link>
            </div> */}
            </div>
        </ContainerWrapper>
    )
}

export default CustomersLoveUs
